import { Fragment, useState, useEffect } from 'react';
import '../css/testPage.less';
import { useParams, useNavigate } from 'react-router-dom';
import { Row, Col, message } from 'antd';
import StopWatch from '../components/StopWatch';
import { TIMED_SURVEYS } from '../utils/timerConfig';
import GroupDetail from './components/GroupDetail';
import Question from './components/Question';
import TestDetail from './components/TestDetail';
import { handlers } from '../helpers/helpers';


const TestPage = ({ refreshTestName, refreshTimer, refreshInitialTimeStamp }) => {
  const [step, setStep] = useState(
    JSON.parse(localStorage.getItem('currentTestStep')) ?
      JSON.parse(localStorage.getItem('currentTestStep')) : 1
  );
  const [countTest, setCountTest] = useState(
    JSON.parse(localStorage.getItem('userData')) && JSON.parse(localStorage.getItem('userData')).countTest ?
      JSON.parse(localStorage.getItem('userData')).countTest : 0
  );
  const [countGroup, setCountGroup] = useState(
    JSON.parse(localStorage.getItem('userData')) && JSON.parse(localStorage.getItem('userData')).countGroup ?
      JSON.parse(localStorage.getItem('userData')).countGroup : 0
  );
  const [countQuestion, setCountQuestion] = useState(
    JSON.parse(localStorage.getItem('userData')) && JSON.parse(localStorage.getItem('userData')).countQuestion ?
      JSON.parse(localStorage.getItem('userData')).countQuestion : 0
  );
  const [buttonsState, setButtonsState] = useState({
    questionsUnanswered: false,
    lastQuestion: false,
    disabledBack: false,
    reachedLast: false,
    isCurrentLastQuestion: false
  })
  const [isTimerActive, setIsTimerActive] = useState(false);
  const [currentSurveyRequiresTimer, setCurrentSurveyRequiresTimer] = useState(false);
  const [timerDuration, setTimerDuration] = useState(0);
  const [timedOutGroupIds, setTimedOutGroupIds] = useState([]);
  const [timerStartedGroupIds, setTimerStartedGroupIds] = useState([]);

  const { countryCode } = useParams();
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem('userData'));
  const currentValidationStep = JSON.parse(localStorage.getItem('currentValidationStep'));
  let userTests;
  let test;
  let testsLength;
  let group;
  let groupsLength;
  let question;
  let questionsLength;
  let answer;

  if (userData && currentValidationStep >= 4) {

    userTests = userData.tests;
    test = userTests[countTest];
    testsLength = userTests.length;
    group = test['groups'][countGroup];
    groupsLength = test['groups'].length;
    question = test['groups'][countGroup]['questions'][countQuestion];
    questionsLength = test['groups'][countGroup]['questions'].length;
    if (question && userData['testsResults'] && userData['testsResults'].length > 0) {
      const answeredQuestion = userData['testsResults'].filter(testsResult => testsResult.questionId === question['question_id'] && testsResult.testId === test.id)
      if (answeredQuestion && answeredQuestion.length > 0) {
        answer = answeredQuestion[0].answer;
      }
    }
  } else {
    navigate(`/examenes/psicologia/${countryCode}`);
  }

  const saveAnswer = (
    questionOptions,
    selectedAnswer
  ) => {
    let _userData = JSON.parse(localStorage.getItem('userData'));
    if (selectedAnswer && !_userData['testsResults'].some(testsResult => testsResult.questionId === question.question_id && testsResult.testId === test.id)) {
      _userData['testsResults'].push(
        {
          testId: test.id,
          form_type: test.form_type,
          admissionPatientExam: group.admission_patient_exam,
          groupId: group.id,
          groupName: group.name,
          survey_code: group.survey_code,
          questionId: question.question_id,
          questionTitle: question.title,
          answer: selectedAnswer,
          questionOptions,
          order: question.order
        });
      localStorage.setItem('userData', JSON.stringify(_userData));
    } else if (selectedAnswer) {
      for (let testsResult of _userData['testsResults']) {
        if (testsResult.questionId === question.question_id) {
          testsResult.answer = selectedAnswer;
        }
      }
      localStorage.setItem('userData', JSON.stringify(_userData));
    }
  }

  const checkAndMarkExamAsPending = async (currentGroup, nextGroup) => {
    if (!currentGroup) return;

    const currentTestId = userData.testId;
    const currentExamId = currentGroup.admission_patient_exam;
    const isBattery = currentTestId.includes('_battery');

    await handlers.checkAndMarkSurveyAsPending({
      isBattery,
      currentExamId: currentExamId,
      test: test,
      testsResults: userData.testsResults
    });
  };

  const onChange = (
    questionOptions,
    selectedAnswer
  ) => {
    if (buttonsState.isCurrentLastQuestion) {
      setIsTimerActive(false);
      setCountQuestion(questionsLength)

      if (currentSurveyRequiresTimer) {
        setTimedOutGroupIds(prevIds => [...prevIds, group.id]);
      }

      if (questionsLength === countQuestion + 1 && groupsLength - 1 > countGroup) {
        const currentGroup = test.groups[countGroup];
        const nextGroup = test.groups[countGroup + 1];
        checkAndMarkExamAsPending(currentGroup, nextGroup);
      }
    } else {
      setCountQuestion(countQuestion + 1)
    }
    updateCurrentData(countTest, countGroup, countQuestion, test.id);
    saveAnswer(questionOptions, selectedAnswer);
  };

  const onReturn = (
    questionOptions,
    selectedAnswer
  ) => {
    saveAnswer(questionOptions, selectedAnswer);
    if (countQuestion > 0 && groupsLength > countGroup && step === 3) {
      setCountQuestion(countQuestion - 1);
    } else if (countQuestion === 0 && countGroup >= 0 && step === 3) {
      setStep(2)
    } else if (countQuestion === 0 && countGroup > 0 && step === 2) {
      setStep(3)
      userTests = userData.tests;
      test = userTests[countTest];
      questionsLength = test['groups'][countGroup - 1]['questions'].length;
      setCountQuestion(questionsLength - 1)
      setCountGroup(countGroup - 1)
    }
    updateCurrentData(countTest, countGroup, countQuestion, test.id);
  }

  const answerMissingQuestion = (
    questionNumber,
    questionOptions,
    selectedAnswer
  ) => {
    setCountQuestion(questionNumber);
    updateCurrentData(countTest, countGroup, countQuestion, test.id);
    saveAnswer(questionOptions, selectedAnswer);
  }

  const setCurrentStep = (stepName, stepValue) => {
    handlers.handleCurrentStep(stepName, stepValue);
  };

  const checkTestState = () => {
    if (questionsLength === countQuestion && groupsLength - 1 > countGroup) {
      const currentGroup = test.groups[countGroup];
      if (currentSurveyRequiresTimer) {
        setTimedOutGroupIds(prevIds => [...prevIds, group.id]);
      }
      const nextGroup = test.groups[countGroup + 1];
      checkAndMarkExamAsPending(currentGroup, nextGroup);
      setCountQuestion(0);
      setCountGroup(countGroup + 1);
      setStep(2);
    }

    if (questionsLength === countQuestion && groupsLength - 1 === countGroup && testsLength > countTest) {
      const currentGroup = test.groups[countGroup];
      if (currentSurveyRequiresTimer) {
        setTimedOutGroupIds(prevIds => [...prevIds, group.id]);
      }
      checkAndMarkExamAsPending(currentGroup, null);
      setCountQuestion(0);
      setCountGroup(0);
      refreshTimer();
      refreshTestName();
      navigate(`/examenes/psicologia/${countryCode}/revision`);
    }
  };

  const controlButton = (countGroup, countQuestion, testId) => {
    const _userData = JSON.parse(localStorage.getItem('userData'));
    const answeredLength = _userData['testsResults'].filter(test => test.groupId === group.id && test.testId === testId).length;
    const questionsUnanswered = answeredLength < questionsLength;
    const lastQuestion = (questionsLength === countQuestion + 1);
    const isCurrentLastQuestion = (answeredLength + 1 === questionsLength)
      && question && !_userData['testsResults'].some(test => test.groupId === group.id && test.testId === testId && question.question_id === test.questionId);
    const reachedLast = lastQuestion || (buttonsState.reachedLast && answeredLength > 0);

    let shouldDisableBack = false;
    if (countGroup === 0 && step === 2) {
      shouldDisableBack = true;
    }
    else if (step === 2 && currentSurveyRequiresTimer) {
      shouldDisableBack = true;
    }
    else {
      const previousGroup = test.groups[countGroup - 1];
      if (previousGroup && (timedOutGroupIds.includes(previousGroup.id) || timerStartedGroupIds.includes(previousGroup.id))) {
        shouldDisableBack = true;
      }
    }
    if (step === 3 && countQuestion === 0 && currentSurveyRequiresTimer && timerStartedGroupIds.includes(group?.id)) {
      shouldDisableBack = true;
    }
    setButtonsState({
      questionsUnanswered: questionsUnanswered,
      lastQuestion: lastQuestion,
      disabledBack: shouldDisableBack,
      reachedLast: reachedLast,
      isCurrentLastQuestion: isCurrentLastQuestion
    });
  }

  const updateCurrentData = (countTest, countGroup, countQuestion, testId) => {
    handlers.handleUserData({ countTest, countGroup, countQuestion, testId });
  };

  const handleTimeUp = () => {
    message.warning('El tiempo ha terminado. Se guardarán las respuestas completadas hasta el momento.');

    if (question && answer) {
      saveAnswer(question.questionOptions, answer);
    }

    const currentGroup = test.groups[countGroup];
    checkAndMarkExamAsPending(currentGroup, null);

    setTimedOutGroupIds(prevIds => [...prevIds, currentGroup.id]);

    setIsTimerActive(false);

    if (groupsLength - 1 > countGroup) {
      setCountQuestion(0);
      setCountGroup(countGroup + 1);
      setStep(2);
    } else {
      refreshTimer();
      refreshTestName();
      navigate(`/examenes/psicologia/${countryCode}/revision`);
    }
  };

  useEffect(() => {
    if (step === 3 && currentSurveyRequiresTimer && group) {
      const groupId = group.id;
      if (!timerStartedGroupIds.includes(groupId)) {
        setIsTimerActive(true);
        setTimerStartedGroupIds(prevIds => [...prevIds, groupId]);
      }
    }
  }, [step, currentSurveyRequiresTimer, group, timerStartedGroupIds]);

  useEffect(() => {
    if (group?.survey_code) {
      const requiresTimer = group.survey_code in TIMED_SURVEYS;
      setCurrentSurveyRequiresTimer(requiresTimer);
      requiresTimer ? setTimerDuration(TIMED_SURVEYS[group.survey_code]) : setTimerDuration(0);
    }
  }, [group?.survey_code]);

  useEffect(() => {
    window.scroll(0, 0);
    if (userData && currentValidationStep >= 4) {
      checkTestState();
      setCurrentStep('currentTestStep', step);
      updateCurrentData(countTest, countGroup, countQuestion, test.id);
      controlButton(countGroup, countQuestion, test.id);
    }
  }, [countTest, countGroup, countQuestion, test.id, step, timedOutGroupIds]);

  return (
    <Fragment>
      {isTimerActive && currentSurveyRequiresTimer && (
        <StopWatch
          timerOn={isTimerActive}
          isCountdown={true}
          initialMinutes={timerDuration}
          onTimeUp={handleTimeUp}
        />
      )}
      {
        userData && question && group && test && step === 1 &&
        <TestDetail
          test={test}
          testsLength={testsLength}
          allTests={userTests}
          group={group}
          setStep={setStep}
          refreshTestName={refreshTestName}
          refreshTimer={refreshTimer}
          userData={userData}
          refreshInitialTimeStamp={refreshInitialTimeStamp}
        />
      }
      {
        userData && question && group && test && step === 2 &&
        <GroupDetail
          group={group}
          setStep={setStep}
          onReturn={onReturn}
          disabledBack={buttonsState.disabledBack}
        />
      }
      {
        userData && question && group && test && step === 3 &&
        <Question
          test={test}
          group={group}
          countGroup={countGroup}
          groupsLength={groupsLength}
          question={question}
          countQuestion={countQuestion}
          questionsLength={questionsLength}
          selectedAnswer={answer}
          setCountQuestion={setCountQuestion}
          onChange={onChange}
          onReturn={onReturn}
          buttonsState={buttonsState}
          answerMissingQuestion={answerMissingQuestion}
        />
      }
    </Fragment>
  );
};

export default TestPage;